import { render, staticRenderFns } from "./input-text.vue?vue&type=template&id=b1a1ca1c&"
import script from "./input-text.vue?vue&type=script&lang=js&"
export * from "./input-text.vue?vue&type=script&lang=js&"
import style0 from "./input-text.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports